module.exports = __webpack_public_path__ + "img/Cepat.7c40253b.png";